export default __webpack_public_path__ + "static/muirgen-e30550fe86479606dca4ff7671b2e327.jpg";